export const AnotherHearing = [
    { value: 'AIJ', label: 'AIJ' },
    { value: 'Conciliação', label: 'Conciliação' },
    { value: 'Sustentação Oral', label: 'Sustentação Oral' },
    { value: 'Outros', label: 'Outros' },
];